import { html, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { when } from "@/common/directives/when";
import EkoElement from "@/utilities/element";
import style from "./spinner.css?inline";

@customElement("eko-spinner")
class Spinner extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true }) color?: string;
  @property({ reflect: true }) label?: string;
  @property({ reflect: true }) size: "full" | "sm" | "md" | "lg" = "md";

  render() {
    return html`
      <div
        class="eko-spinner"
        style=${when(this.color, `--_eko-spinner-color: ${this.color}`)}
        aria-label=${when(this.label)}
        role=${when(this.label, "img")}></div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-spinner": Spinner;
  }
}

export default Spinner;
